import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import AutoSelect from '../../../containers/selects/auto_select';
import { findAllCitiesByDepartmentEvent } from '../../../_events/city/find_city.event';
import { findAllDepartmentsEvent } from '../../../_events/department/find_department.event';
import { message } from 'antd';

const AutoSelectSeller = (props) => {

    const { city } = props;

    const [dataDeps, setDataDeps] = useState([]);
    const [dataCit, setDataCit] = useState([]);
    
    const loadDepartments = () => {
        findAllDepartmentsEvent()
        .then(data => {
            setDataDeps(data.list);
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    const loadCity = (dep) => {
        findAllCitiesByDepartmentEvent(dep)
        .then(data => {
            setDataCit(data.list);
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    useEffect(() => {
        loadDepartments();
    }, []);

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>                
                <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                    <div style={{display: 'flex', flexDirection: 'row', width: '50%'}}>
                        <AutoSelect
                            id='client_department_autoselect'
                            label='Departamento'
                            getOptionLabel={(option) => `${option.name}`}
                            renderOption={(props, option) => (<div {...props}>{`${option.name}`}</div>)}
                            data={dataDeps}
                            onChange = {(value) => {
                                loadCity(value.cod);
                            }}
                            value={city ? city.department : null}
                        />
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', width: '50%'}}>
                        <input id='client_city' hidden defaultValue={city ? city.cod : ''} />
                        <AutoSelect
                            id='client_city_autoselect'
                            label='Ciudad'
                            getOptionLabel={(option) => `${option.name}`}
                            renderOption={(props, option) => (<div {...props}>{`${option.name}`}</div>)}
                            data={dataCit}
                            onChange = {(value) => {
                                document.getElementById('client_city').value = value ? value['cod'] : '';
                            }}
                            value={city ? city : null}
                        />
                    </div>
                </div>                
            </Grid>
        </Grid>
    );

}

export default AutoSelectSeller;